import React from "react";
import { ActivityIndicator, StyleSheet, TouchableOpacity, TouchableOpacityProps, View } from "react-native";
import { PdCheck } from "src/components/Icons";
import { PdText, tPdText } from "src/components/layout";

import { kColors } from "src/kColors";
import { kStyleConst } from "src/kStyle";

export type tPdCheckboxProps = {
  value?: boolean;
  onChange?: (value: boolean) => void;
  isDisabled?: boolean;
  isLoading?: boolean;
} & TouchableOpacityProps;

export const PdCheckbox = React.forwardRef<TouchableOpacity, React.PropsWithChildren<tPdCheckboxProps>>(
  (props, ref) => {
    const { value, isDisabled, isLoading, style, onChange, children, ...rest } = props;

    const handleOnPress = () => {
      if (!isDisabled) {
        onChange?.(!value);
      }
    };

    const hasChildren = React.Children.count(children) > 0;

    return (
      <TouchableOpacity
        ref={ref}
        onPress={handleOnPress}
        style={[styles.pdCheckboxContainer, isDisabled ? styles.opacityMd : {}, style]}
        disabled={isDisabled}
        {...rest}
      >
        {isLoading ? (
          <View style={hasChildren ? styles.mr2 : {}}>
            <ActivityIndicator style={styles.pdCheckboxSpinner} color={kColors.grayPink} />
          </View>
        ) : (
          <View style={[styles.pdCheckboxIconContainer, hasChildren ? styles.mr2 : {}]}>
            {value && <PdCheck color={kColors.brand500} style={styles.pdCheckboxIcon} />}
          </View>
        )}
        {children}
      </TouchableOpacity>
    );
  },
);

export const PdCheckboxLabel: React.FC<tPdText> = ({ style, ...rest }) => {
  return <PdText style={[styles.pdCheckboxLabel, style]} {...rest} />;
};

const styles = StyleSheet.create({
  mr2: {
    marginRight: 2 * kStyleConst.kSpacing,
  },
  opacityMd: {
    opacity: 0.4,
  },
  pdCheckboxContainer: {
    alignItems: "center",
    flexDirection: "row",
  },
  pdCheckboxIcon: {
    height: 10,
    width: 10,
  },
  pdCheckboxIconContainer: {
    alignItems: "center",
    borderColor: kColors.grayPink,
    borderRadius: 3,
    borderWidth: 1,
    height: 16,
    justifyContent: "center",
    width: 16,
  },
  pdCheckboxLabel: {
    color: kColors.brandDark,
    fontSize: 12,
    fontWeight: "400",
    letterSpacing: 1,
  },
  pdCheckboxSpinner: {
    height: 16,
    width: 16,
  },
});
